import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function buildLocalizedPagePath(locale: ViewerLocale, ...segments: string[]): string {
  return `/${[locale, ...segments].map(encodeURIComponent).join("/")}`;
}
